// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zgbm","icon":"styles_icon__240xF"};